var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheckMark = function SvgCircleCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "check mark",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.75 20.5a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5m0-1.5a7.25 7.25 0 1 1 0-14.5 7.25 7.25 0 0 1 0 14.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.714 8.973-3.873 5.166a.26.26 0 0 1-.182.099.26.26 0 0 1-.196-.073l-2-2a.749.749 0 1 0-1.06 1.061l2 2a1.752 1.752 0 0 0 2.637-.187l3.874-5.166a.75.75 0 1 0-1.2-.9",
    clipRule: "evenodd"
  })));
};
export default SvgCircleCheckMark;